<template>
  <div class="container">
    <router-link tag="p" to="/Service">
      <span>查看《服务协议》</span>
      <span class="iconfont"></span>
    </router-link>
    <router-link tag="p" to="/agreeMent">
      <span>查看《隐私政策》</span>
      <span class="iconfont"></span>
    </router-link>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  created () {},
  methods: {}
};
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.container {
  background: @colore;
  min-height: 100vh;
  p {
    .fontSize(16px);
    color: @color3;
    line-height: 100px;
    height:100px;
    background:#fff;
    padding:0 28px;
    .flex();
    justify-content: space-between;
    align-items: center;
    .iconfont{
      width:32px;
      height:32px;
      background:url('../assets/images/icon_indicator_next.png') left center no-repeat;
      background-size:32px 32px;
    }
  }
}
</style>
